import { apiCall } from './api.js';
import { API_ENDPOINTS } from '../utils/constants.js';
import { storage } from '../utils/localStorage.js';

export const projectService = {  // Fetch dashboard data
  fetchDashboard: async () => {
    try {
      
      
      if (!API_ENDPOINTS.DASHBOARD) {
        throw new Error('Dashboard API endpoint is not configured');
      }
      
      const response = await apiCall(API_ENDPOINTS.DASHBOARD, {
        method: 'GET'
      });
      
   
      
      // Based on your API docs: response.data.Dashboard contains projects
      if (response.data && response.data.Dashboard) {
       
        // Map the response to match frontend expectations
        const projects = response.data.Dashboard.map(project => ({
          project_id: project.ID,
          project_name: project.name,
          host_id: project.host?.email || project.host_id,
          collaborators: project.collaborators || [],
          container_status: project.container_status,
          container_url: project.container_url || '',
          port_url: project.port_url || [],
          node_url: project.node_url || '',
          created_at: project.created_at || new Date().toISOString(),
          updated_at: project.updated_at || new Date().toISOString()
        }));
        
        storage.setProjects(projects);
        
        return {
          ...response.data,
          projects: projects
        };
      } else {
        console.warn('No Dashboard data in response:', response.data);
        return {
          projects: []
        };
      }
    } catch (error) {
      console.error('Dashboard fetch error:', error);
      throw error.response?.data || error.message || error;
    }
  },
  
  // Create project
  createProject: async (projectData) => {
    try {
      const response = await apiCall(API_ENDPOINTS.CREATE_PROJECT, {
        method: 'POST',
        data: {
          project_name: projectData.project_name,
          proj_password: projectData.proj_password,
          colloborators: projectData.collaborators // Note: API expects "colloborators" (typo)
        }
      });
      
      // Based on your API docs: response.data.project
      if (response.data.project) {
        // Map the response to match frontend expectations
        const project = {
          project_id: response.data.project.ID,
          project_name: response.data.project.name,
          host_id: response.data.project.host.email,
          collaborators: response.data.project.collaborators || [],
          container_status: response.data.project.container_status,
          container_url: response.data.project.container_url || '',
          port_url: response.data.project.port_url || [],
          node_url: response.data.project.node_url || '',
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        };
        
        storage.addProject(project);
      }
      
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  // Edit collaborators
  editCollaborators: async (project_id, collaborators) => {
    try {
      const response = await apiCall(API_ENDPOINTS.EDIT_COLLABORATORS, {
        method: 'PUT',
        data: {
          project_id: Number(project_id),
          colloborators: collaborators // Note: API expects "colloborators" (typo)
        }
      });
      
      if (response.data.message === "Collaborators updated successfully") {
        storage.updateProject(project_id, { collaborators });
      }
      
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  // Start project
  startProject: async (project_id) => {
    try {
      const response = await apiCall(API_ENDPOINTS.START_PROJECT, {
        method: 'POST',
        data: {
          project_id: Number(project_id)
        }
      });
      
      // Based on your API docs: response includes container_url, port_url
      if (response.data.container_url) {
        storage.updateProject(project_id, {
          container_status: 'running',
          container_url: response.data.container_url,
          port_url: response.data.port_url || [],
          node_url: response.data.node_url || '',
          updated_at: new Date().toISOString()
        });
      }
      
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  // Request project password update
  requestProjectPasswordUpdate: async (projectId) => {
    try {
      console.log('Requesting project password update for project ID:', projectId);
      const response = await apiCall(API_ENDPOINTS.REQUEST_PROJECT_PASSWORD_UPDATE, {
        method: 'POST',
        data: {
          project_id: Number(projectId)
        }
      });
      
      console.log('Project password update request response:', response);
      return response.data;
    } catch (error) {
      console.error('Project password update request error:', error);
      throw error.response?.data || error.message;
    }
  },

  // Complete project password update
  completeProjectPasswordUpdate: async (token, otp, newPassword) => {
    try {
      
        const response = await apiCall(API_ENDPOINTS.COMPLETE_PROJECT_PASSWORD_UPDATE, {
        method: 'POST',
        data: { 
          otp: otp,
          new_password: newPassword 
        },
        authToken: token,  // Use authToken parameter instead of manual headers
        skipAutoRedirect: true  // Prevent automatic logout on 401 errors
      });
      
      console.log('Complete project password update response:', response);
      return response.data;
    } catch (error) {
      console.error('Complete project password update error:', error);
      throw error.response?.data || error.message;
    }
  },

  // Delete project
  deleteProject: async (project_id) => {
    try {
      // Use the login JWT token for Authorization
      const { tokenManager } = await import('../utils/tokenManager.js');
      const authToken = tokenManager.getAuthToken();
      const url = 'https://aws-ec2.devroom.in/api/project/stop-and-delete';
      const response = await apiCall(url, {
        method: 'POST',
        data: { project_id: Number(project_id) },
        authToken
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};